import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ImageAsset } from '../../api/images/image-asset-model';
import { ImageManagerService } from '../../api/images/image-manager.service';
import { MyCampAppConstants } from '../../api/common/constants';
import { MyCampApp } from '../../api/common/enumerations';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import AssetType = MyCampApp.AssetType;
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
    selector: 'mycampapp-image-asset',
    templateUrl: './image-asset.component.html',
    styleUrls: ['./image-asset.component.less']
})
export class ImageAssetComponent implements OnInit, OnChanges, OnDestroy
{
    @ViewChild('overlayPanel', {static: false}) overlayPanel?: OverlayPanel;

    @Input() imageAsset!: ImageAsset;
    @Input() width = 50;
    @Input() height = 50;
    @Input() usePlaceholder = false;
    @Input() showFullSize = false;

    url: string | undefined;
    hasImage = false;
    isYoutubeVideo = false;
    isVimeoVideo = false;
    embeddableVideoUrl?: string;
    safeUrl?: SafeResourceUrl;

    loading = false;

    AssetType = MyCampApp.AssetType;

    private loadAttempts = 0;
    private MAX_LOAD_ATTEMPTS = 3;


    constructor(private imageManager: ImageManagerService,
                public sanitizer: DomSanitizer)
    {
    }

    ngOnInit()
    {
    }

    ngOnDestroy(): void
    {
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        this.isYoutubeVideo = false;
        this.isVimeoVideo = false;
        this.embeddableVideoUrl = undefined;
        this.safeUrl = undefined;
        if (this.imageAsset != undefined && this.imageAsset.AssetType === AssetType.Video)
        {
            this.isYoutubeVideo = this.imageAsset.MediaURL?.indexOf('youtu.be') !== -1;
            this.isVimeoVideo = this.imageAsset.MediaURL?.indexOf('vimeo.com') !== -1;
            if (this.isYoutubeVideo) this.embeddableVideoUrl = this.imageAsset.MediaURL!.replace('//youtu.be/', '//www.youtube.com/embed/');
            if (this.isVimeoVideo)
            {
                const videoId = this.imageAsset.MediaURL!.slice(this.imageAsset.MediaURL!.lastIndexOf('/') + 1);
                this.embeddableVideoUrl = `https://player.vimeo.com/video/${videoId}`;
            }
            if (this.embeddableVideoUrl !== undefined) this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.embeddableVideoUrl);
        }

        if (this.imageAsset == undefined || !this.imageAsset.hasImage)
        {
            this.hasImage = this.usePlaceholder;
            if (this.usePlaceholder) {  this.url = MyCampAppConstants.MissingImageUrl; }
            return;
        }

        this.hasImage = true;
        this.url = this.imageAsset.getUrlForSize(this.width, this.height)!;
        if (this.url != undefined) return;

        // Use closest but request in background so it will be loaded for the future
        this.url = this.imageAsset.getUrlForSize(this.width, this.height, true);
        // this.imageManager.getImageWithSize(this.imageAsset.Id, this.width, this.height).pipe(take(1)).subscribe();
        // this.loadImage();
    }

    get isFullSizeEnabled(): boolean {
        return this.showFullSize &&
            (this.imageAsset.AssetType === AssetType.Image || this.isYoutubeVideo || this.isVimeoVideo);
    }
    // loadImage()
    // {
    //     this.loading = true;
    //     this.loadAttempts++;
    //     this.imageManager.getImageWithSize(this.imageAsset.Id, this.width, this.height).pipe(take(1))
    //         .subscribe((response: any) =>
    //         {
    //             this.url = response.Url;
    //             this.loading = false;
    //         }, () =>
    //         {
    //             if (this.loadAttempts === this.MAX_LOAD_ATTEMPTS)
    //             {
    //                 this.loading = false;
    //                 return;
    //                 // No image for you! :(
    //             }
    //
    //             // Try again
    //             this.loadImage();
    //         });
    // }

    setSpinnerClass()
    {
        return this.width > 75 ? 'regular-spinner-size' : 'compact-spinner-size';
    }

    onImageLoadError()
    {
        if (this.usePlaceholder)
        {
            this.url = MyCampAppConstants.MissingImageUrl;
        }
    }

    toggleOverlay(event: any): void
    {
        this.overlayPanel!.toggle(event);
    }
}
